module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sidebarTextInput",
    staticClass: "sidebar-tabbed-text-input"
  }, [_c('b-tabs', {
    on: {
      "input": _vm.handleTabChange
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.data.tabs), function(input, index) {
    return _c('b-tab', {
      key: input.key,
      staticClass: "tab",
      attrs: {
        "title": input.tabLabel || input.label
      }
    }, [_c('div', {
      staticClass: "col-12 container"
    }, [(_vm.tabIsBeingLoaded(index)) ? _c('div', {
      staticClass: "spinner-container"
    }, [_c('erco-spinner', {
      staticClass: "spinner",
      attrs: {
        "size": "30px",
        "isFixedColor": true
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('erco-text-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.tabIsBeingLoaded(index)),
        expression: "!tabIsBeingLoaded(index)"
      }],
      ref: ("input" + index),
      refInFor: true,
      staticClass: "_input",
      attrs: {
        "label": "",
        "text": input.text,
        "inputType": "textarea",
        "resetable": true,
        "charlength": index === 0 && _vm.computedCharLength
      },
      on: {
        "input": function($event) {
          _vm.handleInput(index, $event)
        },
        "reset": function($event) {
          _vm.handleReset(index)
        }
      }
    })], 1)])
  })), _vm._v(" "), (_vm.changes.length > 0 && !_vm.tabIsBeingLoaded(_vm.tabIndex)) ? _c('b-alert', {
    staticClass: "alert",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [(_vm.changes.length === 1) ? _c('span', [_vm._v("\n\t\t\tEs liegt noch eine unbestätigte Änderung im Reiter " + _vm._s(_vm.buildChangesStrList(_vm.changes)) + " vor\n\t    ")]) : _c('span', [_vm._v("\n\t\t\tEs liegen noch mehrere unbestätigte Änderungen in den Reitern " + _vm._s(_vm.buildChangesStrList(_vm.changes)) + " vor\n\t    ")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d8c010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/TabbedTextInput.vue
// module id = 590
// module chunks = 0